import executeRequest, { RequestOutput, API_GetConfig } from 'app/api'
import { Endpoint } from 'app/api/endpoints'


export type API_PickupPointData = {
  ad?: string
  calendar?: { day?: number, dayDescription?: string, isClosed?: boolean, or?: string }[]
  ci?: string
  co?: string
  cp?: string
  dc?: any
  de?: string
  dp?: string
  id?: number
  lat?: number
  lon?: number
  network?: { id?: number, code?: string, description?: string, urlLogo?: string }
  nt?: any
  pf?: string
  pr?: number
  ra?: string
  tp?: string
  ul?: string
  zi?: string
}

type GetPickupPointDataRequestParams = {
  id: number
  merchantCode: string
}
type GetPickupPointDataResponse = {
  data: API_PickupPointData
}
enum GetPickupPointDataReponseError {
}
export async function getPickupPointData(params: GetPickupPointDataRequestParams, config?: API_GetConfig, output?: RequestOutput<GetPickupPointDataResponse, GetPickupPointDataReponseError>) {
  executeRequest({
    endpoint: Endpoint.GetPickupPointData,
    config: config,
    params: params,
    output: output,
  })
}
